import React from "react";
import { Heading } from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import FormField from "../../Common/FormField";
import { useCountry } from "../CountryContext";

const ContactInfoSection = ({ formik }) => {
  const { t } = useTranslation("common");
  const { isModifyUser } = useCountry();
  return (
    <section id="contact-info">
      <div className="row">
        <div className="col-xs-12">
          <Heading
            level={4}
            className="heading-4 dls-deep-blue pad-2-t pad-2-b"
          >
            {isModifyUser
              ? t("newUserUK.ModifyContactInfoHeading")
              : t("newUserUK.contactInfoHeading")}
          </Heading>
        </div>
        <FormField
          id="phoneNumber"
          name="phoneNumber"
          label={t("newuser.workTelephoneNumber")}
          value={formik.values.phoneNumber}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          hint={t("newuser.phoneNumberHint")}
          error={formik.touched.phoneNumber && formik.errors.phoneNumber}
        />
        <FormField
          id="emailId"
          name="emailId"
          label={t("newuser.workEmail")}
          value={formik.values.emailId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.emailId && formik.errors.emailId}
        />
      </div>
    </section>
  );
};

export default ContactInfoSection;
